import { render } from "./DonateCart.vue?vue&type=template&id=dc3a06b2"
import script from "./DonateCart.vue?vue&type=script&lang=js"
export * from "./DonateCart.vue?vue&type=script&lang=js"
script.render = render

export default script